import VergeNotificationsDrawerAppWrapper from "@components/notifications/VergeNotificationsDrawerAppWrapper";
import { FunctionComponent, ReactNode } from "react";

import DevOverlayStack from "src/components/dev/DevOverlayStack";

import CommentsPreviewAppWrapper from "./CommentsPreviewAppWrapper";

/** Composes Verge notifications wrapper with optional Coral staging preview. */
const CskAppContentWrapper: FunctionComponent<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <CommentsPreviewAppWrapper>
      <DevOverlayStack />
      <VergeNotificationsDrawerAppWrapper>
        {children}
      </VergeNotificationsDrawerAppWrapper>
    </CommentsPreviewAppWrapper>
  );
};

export default CskAppContentWrapper;
